import pattern1 from '../../assets/About/PattenMatch.svg'
import about from '../../assets/About/aboutPage.avif'
import office from '../../assets/About/topIAbout.avif'
export default function Aboutus() {


    return (
        <section className="relative min-h-[700px] lg:min-h-[790px] overflow-hidden">

            {/* PATTERN / OFFICE IMAGE */}
            <img
                src={pattern1}
                alt="Pattern"
                className="absolute inset-0 w-full h-full object-cover z-10 hidden lg:block"
                onContextMenu={(e) => e.preventDefault()}
                draggable={false}
            />
            <img
                src={office}
                alt="Office"
                className="absolute inset-0 w-full h-full object-cover z-10 block lg:hidden"
                onContextMenu={(e) => e.preventDefault()}
                draggable={false}
            />

            {/* TEXT */}
            <div  className="absolute z-20 top-60 left-4 lg:top-16 lg:left-10 2xl:left-48 " >
                <div className="py-8 md:py-12 px-4 sm:px-6  lg:px-24">
                    <div className=" max-w-7xl rounded-lg bg-white/70 px-3 py-3">
                        <div className="max-w-[500px]">

                            <span className="text-sm text-secondary-600 bg-secondary-100 py-2 px-4 rounded-full">
                                About Us
                            </span>

                            <h1 className="font-semibold text-xl md:text-4xl 2xl:text-5xl text-black tracking-[0.7px] py-6 lg:py-8">
                                Building the{" "}
                                <span className="text-secondary-500">
                                    Future of Enterprise Technology
                                </span>
                            </h1>

                            <p className="font-medium text-base 2xl:text-lg text-gray-700 font-secondary leading-relaxed pt-0 pb-3 lg:py-5">
                                SAN Technovation Pvt Ltd is a Product + IT Services company building
                                intelligent digital systems for modern businesses.
                            </p>

                            <p className="font-medium text-base 2xl:text-lg text-gray-700 font-secondary leading-relaxed">
                                We design and engineer platforms that are reliable, scalable, and
                                grounded in real-world needs. Our focus is on clarity, performance,
                                and long-term value — not unnecessary complexity.
                            </p>

                        </div>
                    </div>
                </div>
            </div>

            {/* BUILDING IMAGE (Laptop + Desktop only) */}
            <div className="absolute inset-0 -z-10 overflow-hidden hidden lg:block">
                <img
                    src={about}
                    alt="About"
                    className="w-full h-full object-cover"
                    style={{ objectPosition: "right center" }}
                    onContextMenu={(e) => e.preventDefault()}
                    draggable={false}
                />
            </div>

        </section>
    );
}
